import { createAsyncThunk } from '@reduxjs/toolkit';

import { type AsyncThunkConfig, PatientTableItem, ECGWaveFormResponseDto, ECGCaptureResponseDto } from 'types/types';
import { getECGCaptureByPatientId, getECGCapturesByFacilityId } from 'api/controllers/ecg-capture-controller';
import { GetEcgsByFacilityRequestDto } from 'types/types/dto';

const getECGCapture = createAsyncThunk<ECGWaveFormResponseDto[], string, AsyncThunkConfig>(
  'ecg/getCapture',
  async (id) => {
    try {
      return await getECGCaptureByPatientId(id, 2);
    } catch (error) {
      console.error(error, 'error in ecg/getCapture action');

      return [];
    }
  },
);

type GetECGByIdPayload = {
  data: PatientTableItem[];
  limit?: number;
};

const getPatientsECG = createAsyncThunk<PromiseSettledResult<ECGWaveFormResponseDto[]>[], GetECGByIdPayload>(
  'ecg/getEcgsByPatientId',
  async (payload) => {
    const { data, limit } = payload;

    return await Promise.allSettled(data.map((patient) => getECGCaptureByPatientId(patient.id, limit ?? 2)));
  },
);

const getFacilitiesEcg = createAsyncThunk<ECGCaptureResponseDto[], GetEcgsByFacilityRequestDto, AsyncThunkConfig>(
  'ecg/getFacilitiesEcg',
  async (payload) => {
    const { id, skip, limit } = payload;

    return getECGCapturesByFacilityId(id, skip, limit);
  },
);

export { getECGCapture, getPatientsECG, getFacilitiesEcg };
